import { Routes } from '@angular/router'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { ExternalDashboardsSettingsComponent } from './external-dashboard-settings.component'

export const gisRoutes: Routes = [
  {
    path: 'admin/settings/external_dashboards_settings',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: ExternalDashboardsSettingsComponent,
        data: {
          permissions: {
            only: 'EXTERNAL_DASHBOARD_SETTINGS',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
